module.exports = __webpack_public_path__ + "img/EgyptTechTrebuchetS_ua.1698b14e.webp";